import React from 'react';
import './DeviceInventory.less';
import { devicesInventory } from '../../utilities/data';
import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';

const { device_types } = devicesInventory;

const DeviceGeneralInfoCard = ({ device, selectedDeviceInfo }) => {
  const trans = useSelector(translator);

  const renderExpandedInfo = () => (
    <div className="expanded-device-info">
      {selectedDeviceInfo.map((info) => (
        <div key={info.key} className="info-row">
          <div className="info-key">{info.key}:</div>
          <div className="info-value">{info.value}</div>
        </div>
      ))}
    </div>
  );

  return (
    <div
      className={`small-device-card ${
        device?.modelnumber &&
        device_types?.smart_camera_devices?.models?.includes(device?.modelnumber)
          ? 'hc200-styled-small-device-card '
          : ''
      }`}
    >
      <div className="general-info-label">{trans('GENERALINFORMATION')}</div>
      {renderExpandedInfo()}
    </div>
  );
};

export default DeviceGeneralInfoCard;
